<script>

import config from '@/config'
import constant from '@/constant'
import { stringify } from 'querystring'

export default {
  name: 'GoogleLoginButtonMixin',
  props: {
    type: {
      type: String,
      default: 'login',
    },
  },
  data: () => {
    return {
      isWhiteLabelUser: false,
      submittingGG: false,
      showButtonLogin: false,
    }
  },
  mounted() {
    if (window.location.host !== config.domain) {
      this.isWhiteLabelUser = true
    }
    this.showButtonLogin = !this.isWhiteLabelUser &&
        config.region !== constant.euRegion &&
        this.$route.query.fromIframe !== 'true'
  },
  methods: {
    handleGoogleSignin() {
      if (!this.showButtonLogin) {
        return
      }
      this.submittingGG = true

      const {
        GOOGLE_SIGNIN_FROM,
        GOOGLE_SIGNIN_SOURCE,
        GOOGLE_SIGNIN_REDIRECT,
      } = constant.storageKeys
      window.localStorage.setItem(GOOGLE_SIGNIN_FROM, this.type)
      window.localStorage.setItem(GOOGLE_SIGNIN_SOURCE, window.location.href)
      // const redirect = Util.getParamValue('redirect', window.location.href)
      const redirect = window.location.href
      if (redirect) {
        window.localStorage.setItem(GOOGLE_SIGNIN_REDIRECT, redirect)
      }

      setTimeout(() => {
        this.submittingGG = false

        const scopes = [
          'https://www.googleapis.com/auth/userinfo.email',
          'https://www.googleapis.com/auth/userinfo.profile',
        ]
        const stringifiedParams = stringify({
          client_id: config.googleClientId,
          redirect_uri: config.googleRedirect,
          scope: scopes.join(' '),
          response_type: 'code',
          access_type: 'offline',
          prompt: 'consent',
        })

        const oauth2Url = `https://accounts.google.com/o/oauth2/v2/auth?${stringifiedParams}`
        this.$func.go(oauth2Url)
      }, 1000) // give timeout to avoid cancel gaTracking
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
